import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type { LogsPage, LogsQuery } from 'shared-models/browser';

export type {
  LogEntryView,
  LogLevel,
  LogPlace,
  LogsPage,
  LogsQuery,
} from 'shared-models/browser';

class AdminLogsService {
  async list(query: LogsQuery = {}): Promise<LogsPage> {
    try {
      const response = await authenticatedInstance.get<LogsPage>('/logs', { params: query });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת יומן השגיאות נכשלה'));
    }
  }

  async ignore(logId: number): Promise<void> {
    try {
      await authenticatedInstance.post('/logs/ignores', { logId });
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'ההתעלמות מהשגיאה נכשלה'));
    }
  }

  async unignore(logId: number): Promise<void> {
    try {
      await authenticatedInstance.delete('/logs/ignores', { params: { logId } });
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'ביטול ההתעלמות נכשל'));
    }
  }
}

export const adminLogsService = new AdminLogsService();
